<template>
    <div id="app">
        <v-app id="inspire">
            <div>
            <!-- <v-switch
                v-model="reverse"
                label=""
            ></v-switch> -->
            <v-timeline
                :reverse="reverse"
                :dense="$vuetify.breakpoint.smAndDown"
            >
                <v-timeline-item
                    :key="1"
                >
                    <span slot="opposite">2010 - 2013</span>
                    <v-card class="elevation-2">
                        <v-card-title class="headline">
                            Bachelor of Sciences in Computer Science
                        </v-card-title>
                        <v-card-subtitle>
                             Hong Kong Baptist University
                        </v-card-subtitle>
                        <v-card-text>
                           <ul>
                               <li>Object Oriented Programming (Java)</li>
                               <li>Database Management</li>
                               <li>Data Structure and Algorithms</li>
                               <li>Computer Organization</li>
                               <li>Structured Programming (C)</li>
                               <li>Operating System</li>
                               <li>Software Engineering</li>
                               <li>Design and Analysis of Algorithms</li>
                               <li>Data Communication and Networking</li>
                               <li>Internet and the World Wide Web</li>
                               <li>Introduction to Web Intelligence</li>
                               <li>Database System Implementaion</li>
                               <li>Mobile Computing</li>
                               <li>Interactive Computing for Visual Communication</li>
                           </ul>
                        </v-card-text>
                    </v-card>
                </v-timeline-item>
                <v-timeline-item
                    :key="2"
                >
                    <span slot="opposite">2008 - 2010</span>
                    <v-card class="elevation-2">
                        <v-card-title class="headline">
                            Higher Diploma in Software Engineering   
                        </v-card-title>
                        <v-card-subtitle>
                            Hong Kong Institute of Vocational Education (Tsing Yi)
                        </v-card-subtitle>
                        <v-card-text>
                            <ul>
                                <li>Computer Organization & Operating System</li>
                                <li>Database Principles & Administration</li>
                                <li>Networking Technology</li>
                                <li>Programming (Java)</li>
                                <li>Advanced Programming (Java)</li>
                                <li>GUI Programming</li>
                                <li>Internet and Server Programming (PHP)</li>
                                <li>Object Oriented Technology</li>
                                <li>Software Development Process & Methodology</li>
                                <li>E-Commerce Application Development</li>
                                <li>Advanced Development & Tools</li>
                                <li>Enterprise Software</li>
                                <li>Mobile Computing (Java)</li>
                                <li>Contemporary Topics in Software Engineering</li>
                            </ul>
                        </v-card-text>
                    </v-card>
                </v-timeline-item>
            </v-timeline>
            </div>
        </v-app>
    </div>
</template>

<script>
export default {
    data: () => ({
        reverse: true,
    }),
}
</script>